var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.095,
    height: 18.857,
    fill: "none",
    viewBox: "0 0 24.095 18.857"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFF5B9",
    strokeLinecap: "round",
    strokeWidth: 2.095
  }, /*#__PURE__*/React.createElement(Path, {
    strokeLinejoin: "round",
    d: "M2.095 3.143 9.808 8.71a3.85 3.85 0 0 0 4.479 0L22 3.143"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20.603 1.048H3.493c-1.351 0-2.445 1.072-2.445 2.394v11.973c0 1.322 1.094 2.395 2.444 2.395h17.111c1.35 0 2.445-1.073 2.445-2.395V3.442c0-1.322-1.095-2.394-2.445-2.394Z"
  }))));
};
export default SvgEmail;